import React, { useState } from "react";
import { BooleanField, Button, Datagrid, DateField, ListContextProvider, NumberField } from "react-admin";
import HistoryIcon from "@mui/icons-material/History";
import { settings } from "app";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import UserField from "server/components/Fields/UserField";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";

const PracticeResultHistoryDialog = ({ educationId, practiceId, semester }) => {
  const notifyError = useNotifyError();
  const [history, setHistory] = useState([]);

  const fetchHistory = async () => {
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getStudentPracticeResultHistory(educationId, practiceId, semester),
        null,
        "GET",
      );
      setHistory(data ?? []);
    } catch (err) {
      notifyError(err);
      return false;
    }
  };

  return (
    <ConfirmModal
      onOpen={fetchHistory}
      isConfirmButton={false}
      dialogSize="md"
      titleContent="История на промените"
      triggerButton={
        <Button
          label="История"
          startIcon={<HistoryIcon />}
          variant="contained"
          size="small"
        />
      }
    >
      <ListContextProvider value={{ data: history }}>
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
          sx={{ margin: 2, ...settings.style.secondaryDatagrid }}
        >
          <BooleanField
            source="completed"
            label="Завършена"
            sortable={false}
          />
          <NumberField
            source="grade"
            label="Оценка"
            textAlign="left"
            emptyText="-"
            sortable={false}
          />
          <UserField
            source="createdByUserId"
            label="Променено от"
          />
          <DateField
            source="createdOn"
            label="Дата"
            locales="bg-BG"
            showTime
            sortable={false}
          />
        </Datagrid>
      </ListContextProvider>
    </ConfirmModal>
  );
};

export default PracticeResultHistoryDialog;
